import Vue from 'vue'
import Vuex from 'vuex'
import axios from "axios";

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        //apiServer: "https://tradeinpool.com:3011",
        apiServer: "https://tradeinpool.com:4101/api/",
        userLoaded: false,
        userMember: false,
        token: localStorage.getItem('access_token') || null,
        userData: {},
    },
    // SETTERS:
    mutations: {
        authorize(state, data) {
            state.userData = data.user
            state.userLoaded = true
        },
        destroyUser(state) {
            state.userData = {}
            state.userLoaded = false
        },
        setUserdata(state, user) {
            state.userData = user
            state.userLoaded = true
        },
        retrieveToken(state, data) {
            state.userData = data.user
            state.userLoaded = true
        },
    },
    actions: {
        register(context, data) {
            return new Promise((resolve, reject) => {
                axios.post(this.state.apiServer + "/users/register", {
                        user: data
                    })
                    .then(response => {
                        localStorage.setItem('access_token', response.data.user.token)
                        context.commit('retrieveToken', response.data)
                        axios.defaults.headers.common['Authorization'] = `Token ${response.data.user.token}`
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        loginRequest(context, credentials) {
            return new Promise((resolve, reject) => {
                axios.post(this.state.apiServer + "/users/login", {
                        user: {
                            email: credentials.email,
                            password: credentials.password
                        }
                    })
                    .then(response => {
                        localStorage.setItem('access_token', response.data.user.token)
                        context.commit('authorize', response.data)
                        axios.defaults.headers.common['Authorization'] = `Token ${response.data.user.token}`
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        getUserdata(context) {
            axios.defaults.headers.common['Authorization'] = `Token ${localStorage.getItem('access_token')}`
            return new Promise((resolve, reject) => {
                axios.post(this.state.apiServer + "/users/current")
                    .then(response => {
                        localStorage.setItem('access_token', response.data.token)
                        context.commit('setUserdata', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        context.commit('destroyUser')
                        localStorage.removeItem('access_token')
                        delete axios.defaults.headers.common['Authorization']
                        reject(error)
                    })
            })
        },

        retrieveToken(context, credentials) {
            return new Promise((resolve, reject) => {
                axios.post(this.state.apiServer + "/users/login", {
                        user: {
                            email: credentials.email,
                            password: credentials.password
                        }
                    })
                    .then(response => {
                        localStorage.setItem('access_token', response.data.user.token)
                        context.commit('retrieveToken', response.data)
                        axios.defaults.headers.common['Authorization'] = `Token ${response.data.user.token}`
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        destroyToken(context) {
            localStorage.removeItem('access_token')
            context.commit('destroyUser')
            delete axios.defaults.headers.common['Authorization']
        },
    },
    getters: {
        loggedIn(state) {
            return state.token !== null
        },
        apiServer(state) {
            return state.apiServer
        },
        userLoaded(state) {
            return state.userLoaded
        },
        username(state) {
            return state.userData.username
        },
        userid(state) {
            return state.userData._id
        },
    },

})

export default store